import React from 'react';
// src/constants/images.ts
export const IMAGES = {
  heroBg: process.env.PUBLIC_URL + '/images/hero.webp',
};

